<template>
    <div class="main-email">
        <div class="main-content-email">
            <div class="title-div">
                <div class="icon-text-header">
                    <div class="icon-div">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="380"
                            height="380"
                            viewBox="0 0 480 480"
                            fill="none"
                            class="pattern"
                            opacity="0.4"
                        >
                            <defs>
                                <clipPath id="clip-circle">
                                    <rect x="190" y="190" width="240" height="240" />
                                </clipPath>
                            </defs>
                            <g clip-path="url(#clip-circle)">
                                <circle cx="240" cy="240" r="60" stroke="#E4E4E7" />
                                <circle cx="240" cy="240" r="92" stroke="#E4E4E7" />
                                <circle cx="240" cy="240" r="124" stroke="#E4E4E7" />
                                <circle cx="240" cy="240" r="156" stroke="#E4E4E7" />
                            </g>
                        </svg>
                        <vault-icon />
                    </div>
                    <header-phone-verification @closeDialog="closeDialog" />
                </div>
                <div class="title-wrapper">
                    <main-phone-verification @closeDialog="closeDialog" />
                </div>
            </div>
        </div>
    </div>
</template>
<script setup lang="ts">
import { ModalNames } from '~/types/modals';

import HeaderPhoneVerification from './HeaderPhoneVerification.vue';
import MainPhoneVerification from './MainPhoneVerification.vue';

import VaultIcon from '~/assets/images/icons/vault-icon.svg';

const dialogRef =   getDialogRef(ModalNames.PHONE_VERIFICATION);
const closeDialog = () => {
    dialogRef.value.close();
};
</script>
<style lang="scss" scoped>
.main-email {
    @apply sm:max-w-xl w-11/12 rounded-lg bg-white mx-auto h-auto;

    .main-content-email {
        @apply flex items-start gap-4 self-stretch p-6 pt-6 pb-0 bg-white rounded-lg;

        .icon-div {
            @apply relative w-12 h-12 p-3 justify-center items-center rounded-full bg-gray-100;

            .pattern {
                @apply absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 pointer-events-none;
            }
        }

        .content-wrapper {
            @apply items-start gap-[4px] flex-1 flex flex-col;
        }
    }
}
.title-div {
    @apply flex flex-col items-start gap-1 self-stretch w-full;
}
.icon-text-header{
    @apply flex flex-row items-start gap-4 items-start w-full ;
}
.title-wrapper {
    @apply flex flex-col items-start gap-1 sm:flex-1 sm:w-auto w-full sm:pl-16;
}
</style>
